import { useClerk } from '@clerk/tanstack-react-start'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Center, Container, Stack, Text, Title } from '@mantine/core'
import { useEffect, useState } from 'react'
import { usePostHog } from '@/lib/posthog'

export const Route = createFileRoute('/sign-out')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect_url: (search.redirect_url as string) || '',
  }),
  component: SignOutPage,
})

function SignOutPage() {
  const { redirect_url } = Route.useSearch()
  const posthog = usePostHog()
  const clerk = useClerk()
  const signOut = clerk.signOut
  const isLoaded = 'isLoaded' in clerk && typeof clerk.isLoaded === 'boolean' ? clerk.isLoaded : true
  const navigate = useNavigate()
  const [done, setDone] = useState(false)

  useEffect(() => {
    if (!isLoaded) return

    const redirectTo = redirect_url || '/'

    // Reset PostHog identity before redirect (prevents session bleed on shared devices)
    // posthog may be undefined during deferred loading or if blocked by adblocker
    if (posthog) posthog.reset()

    signOut({ redirectUrl: redirectTo })
      .then(() => {
        setDone(true)
        navigate({ to: redirectTo })
      })
      .catch(() => {
        setDone(true)
        navigate({ to: redirectTo })
      })
  }, [isLoaded, signOut, redirect_url, navigate, posthog])

  return (
    <Container size="xs" py="xl">
      <Stack align="center" gap="xl">
        <Stack align="center" gap="xs">
          <Title order={2}>Signing out</Title>
          <Text c="dimmed" ta="center">
            {done ? 'Redirecting…' : 'Please wait while we sign you out.'}
          </Text>
        </Stack>
        {done && (
          <Center>
            <Text
              component="a"
              href={redirect_url || '/'}
              c="blue"
              style={{ cursor: 'pointer' }}
            >
              Click here if you are not redirected
            </Text>
          </Center>
        )}
      </Stack>
    </Container>
  )
}
